class DigitalPayListItemController {
    constructor($element, moveFocus) {
        this.$element = $element;
        this.moveFocus = moveFocus;
    }

    onClickProxy() {
        /*
            div.digitalPayListItem provides a clickable target for mouse users.
            It is not keyboard accessible because it is an interactive element with child
            interactive elements (inputs for credit card CVV and gift card balance)
            which causes issues with screen readers. Don't allow the div to have focus.
            On click, shift focus to the hidden keyboard accessible button.
        */
        this.onClick();
        this.moveFocus(() => this.$element.find('.digitalPayListItem-button'));
    }
}

DigitalPayListItemController.$inject = ['$element', 'MoveFocus'];

const digitalPayListItemComponentDefinition = {
    controller: DigitalPayListItemController,
    template: require('./digital-pay-list-item.component.html').trim(),
    transclude: true,
    bindings: {
        icon: '@',
        isSelected: '<?',
        isDisabled: '<?', // Overrides selected
        isCondensed: '<?',
        isClickEnabled: '<?',
        isError: '<?', // Overrides selected and disabled
        labelledBy: '<?', // The ID of the element describing the instrument
        onClick: '&?',
        tickStampClass: '@', // Class Modifier for the tick stamp
    },
};

module.exports = {
    digitalPayListItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-list-item.component.js